exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav.nav-tabs{margin-top:2em}.table th:hover{cursor:pointer;text-decoration:underline}.table th.sort-asc:after{content:\" \\25B2\"}.table th.sort-desc:after{content:\" \\25BC\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/postcss-loader!../~/stylus-loader!./ui/projects/list/styles.styl
// module id = 950
// module chunks = 0